var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgQrCode = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.96,6.48v-3.52h4.03V0H0v6.48h2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.01,2.96h4.03v3.52h2.96V0h-6.99v2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99,27.04H2.96v-4.54H0v7.49h6.99v-2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.04,22.51v4.54h-4.03v2.96h6.99v-7.49h-2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22,5.32v7.52h7.52v-7.52h-7.52ZM11.4,11.5h-4.83v-4.83h4.83v4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22,17.58v7.52h7.52v-7.52h-7.52ZM11.4,23.76h-4.83v-4.83h4.83v4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7,21.13v3.97h3.97v-3.97h-3.97ZM24.96,24.39h-2.55v-2.55h2.55v2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.12,21.13v3.97h3.97v-3.97h-3.97ZM19.38,24.39h-2.55v-2.55h2.55v2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.08,15.97v3.97h3.97v-3.97h-3.97ZM22.34,19.23h-2.55v-2.55h2.55v2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.15,5.32v7.52h7.52v-7.52h-7.52ZM24.33,11.5h-4.83v-4.83h4.83v4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.05,15.97h-3.97v3.97h3.97v-3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.09,21.13h-3.97v3.97h3.97v-3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.67,21.13h-3.97v3.97h3.97v-3.97Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQrCode, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/qr_code.4db883f2.svg";
export { ForwardRef as ReactComponent };